export default __webpack_public_path__ + "static/B0147-c79cd328989b1560e107a4b99821ba62.png";